import React from "react";
import CategoryProductList from "./CategoryProductList";

const TowbarParts = () => {
  return (
    <CategoryProductList
      categoryName="Towbar Parts"
      categorySlug="towbar"
    />
  );
};

export default TowbarParts;
